import { render, staticRenderFns } from "./groupWelcomeResources.vue?vue&type=template&id=13422dca&scoped=true&"
import script from "./groupWelcomeResources.vue?vue&type=script&lang=js&"
export * from "./groupWelcomeResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13422dca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13422dca')) {
      api.createRecord('13422dca', component.options)
    } else {
      api.reload('13422dca', component.options)
    }
    module.hot.accept("./groupWelcomeResources.vue?vue&type=template&id=13422dca&scoped=true&", function () {
      api.rerender('13422dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/operate/groupWelcomeResources/groupWelcomeResources.vue"
export default component.exports